// extracted by mini-css-extract-plugin
export default {"wrapper":"Switch_wrapper__1Mt7-","isChecked":"Switch_isChecked__xeeoM"};